module.exports = __webpack_public_path__ + "static/media/goalProcessV2.0200d0e5.png";